import styled from 'styled-components/macro'

import { Text, Button, type ButtonVariant, type TypographyVariant } from '@loadsmart/miranda-react'
import { getToken, type ColorToken, type Token } from '@loadsmart/miranda-react/dist/tokens'

import bannerLinesImg from 'core/ui/assets/banner-lines.png'
import { Icon } from 'core/ui/components/icon/Icon'
import useWindowWidth from 'core/ui/hooks/useWindowWidth'

import { intSizes } from 'legacy/styles/screen'
import { analytics } from 'legacy/utils/analytics'
import { user } from 'legacy/utils/user'

const Banner = styled.div<{ $bannerBackgroundColor: Token; $bannerBackgroundImage?: string }>`
  padding: ${getToken('spacing-10')};
  background-image: ${({ $bannerBackgroundImage }) => `url(${$bannerBackgroundImage})`};
  align-items: center;
  border-radius: ${getToken('border-radius-s')};
  background-color: ${({ $bannerBackgroundColor }) => `rgb(${getToken($bannerBackgroundColor)})`};
  display: flex;
  justify-content: space-between;
`

export type BannerConfig = {
  display: boolean
  bannerText: string
  bannerTextVariant: TypographyVariant
  buttonText: string
  bannerBackgroundColor: Token
  bannerTextColor: ColorToken
  buttonVariant: ButtonVariant
  buttonURL: string
  buttonTextColor: string
  bannerBackgroundImage?: string
}

function AdvertisingBanner({
  buttonURL,
  bannerBackgroundColor,
  bannerBackgroundImage = bannerLinesImg,
  bannerTextColor,
  bannerTextVariant,
  bannerText,
  buttonVariant,
  buttonText,
}: BannerConfig) {
  const windowWidth = useWindowWidth()
  const isDesktop = windowWidth > intSizes.md

  function openAndSendToMixpanel() {
    analytics.track('Loadboard / Ads Banner / Click', {
      firstName: user.firstName(),
      lastName: user.lastName(),
      email: user.email(),
      role: user.role,
      company: user.companyId,
    })
    window.open(buttonURL, '_blank', 'noopener noreferrer')
  }

  return (
    <Banner
      $bannerBackgroundColor={bannerBackgroundColor}
      $bannerBackgroundImage={bannerBackgroundImage}
    >
      <Text color={bannerTextColor} variant={bannerTextVariant}>
        {bannerText}
      </Text>

      {isDesktop ? (
        <Button type="button" variant={buttonVariant} size="large" onClick={openAndSendToMixpanel}>
          {buttonText}
        </Button>
      ) : (
        <Button type="button" variant="icon" size="large" onClick={openAndSendToMixpanel}>
          <Icon name="arrow-right" />
        </Button>
      )}
    </Banner>
  )
}

export { AdvertisingBanner }
